// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CustomerInfoCmp from "./CustomerInfoCmp.bs.js";
import * as CustomerOrderTableWrapper from "./CustomerOrderTableWrapper.bs.js";

function CustomerOrderDetailsCmp(Props) {
  var openSnackbar = Props.openSnackbar;
  var customer_id = Props.customer_id;
  var customer_data = Props.customer_data;
  var cashback_data = Props.cashback_data;
  var porter_gold_details_state = Props.porter_gold_details_state;
  var dispatch = Props.dispatch;
  var phone_number = Props.phone_number;
  var geo_region_items = Props.geo_region_items;
  return React.createElement("div", {
              className: "customer-order-card-container"
            }, React.createElement(CustomerInfoCmp.make, {
                  openSnackbar: openSnackbar,
                  customer_id: customer_id,
                  customer_data: customer_data,
                  cashback_data: cashback_data,
                  porter_gold_details_state: porter_gold_details_state,
                  dispatch: dispatch,
                  phone_number: phone_number,
                  geo_region_items: geo_region_items
                }), React.createElement(CustomerOrderTableWrapper.make, {
                  uuid: customer_data.summary.uuid,
                  mobile: customer_data.summary.mobile,
                  customer_id: customer_id
                }));
}

var make = CustomerOrderDetailsCmp;

export {
  make ,
  
}
/* react Not a pure module */
